<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center mt-4">
      <div class="w-50-porcento pr-2">
        <SysDatePicker
          v-model="filtros.data_inicial"
          outlined
          :data_maxima="DATA_ATUAL"
          hide-details
          titulo_label="Data Inicial"
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysDatePicker
          v-model="filtros.data_final"
          titulo_label="Data Final"
          :data_maxima="DATA_ATUAL"
          outlined
          hide-details
        />
      </div>
    </div>

    <SysGrupoAutocomplete
      v-model="filtros.grupo"
      label="Grupos"
      outlined
      hide-details
      class="mt-4"
    />

    <SysTiposProdutoAutocomplete
      v-model="filtros.tipos_produtos"
      class="mt-4"
    />

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      hide-details
      multiple
      class="mt-4"
      :ids-segmento="filtros.segmentos"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import $axios from "@/api/api";
import SysDatePicker from "@/components/utils/SysDatePicker.vue";
import moment from 'moment';
import SysTiposProdutoAutocomplete from "@/components/indicadores/SysTiposProdutoAutocomplete.vue";
import TiposProdutoAutocomplete from "@/components/indicadores/SysTiposProdutoAutocomplete.vue";

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    TiposProdutoAutocomplete,
    SysTiposProdutoAutocomplete,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysDatePicker
},
  data: () => ({
    filtros: {
      grupo: 1,
      filial: -1,
      tipos_produtos: ['PRODUTOS_NAO_COMBINADOS', 'PRODUTOS_COMBINADOS'],
      segmentos: [],
      fornecedores: [],
      compradores: [],
      data_inicial: '',
      data_final: ''
    }
  }),
  computed: {
    DATA_ATUAL() {
      return moment().format('YYYY-MM-DD');
    }
  },
  watch: {
    DIALOG_ATIVO(valor) {
      if(!valor) {
        this.filtros.segmentos = [];
        this.filtros.fornecedores = [];
        this.filtros.compradores = [];
      }
    }
  },
  methods: {
    gerarRelatorio() {
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
